






























































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { ITag, ITask, TagCategory, TaskModel } from 'admiral-core';
import { formatCustomerDisplayName } from '@/utils/formatCustomerAddress';
import { CalendarIcon, CircleIcon, DiscIcon, ListIcon, XIcon } from 'vue-feather-icons';
import Multiselect from 'vue-multiselect';
import PolicyTimeline from '@/views/pages/policies/PolicyTimeline.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { TaskApi } from '@/services/TaskApi';
import { TagApi } from '@/services/TagApi';
import PolicySelect from '@/components/common/selects/PolicySelect.vue';
import UserSelect from '@/components/common/selects/UserSelect.vue';
import TaskForm from '@/forms/TaskForm.vue';
import { FormMixin } from '@/mixins/FormMixin';
import FormSubmit from '@/components/common/forms/FormSubmit.vue';
import { BModal } from 'bootstrap-vue';
import { PolicyApi } from '@/services/PolicyApi';
import TaskTimeline from '@/views/pages/tasks/TaskTimeline.vue';

@Component({
  name: 'edit-task-modal',
  components: {
    TaskTimeline,
    ListIcon,
    FormSubmit,
    TaskForm,
    UserSelect,
    PolicySelect,
    PolicyTimeline,
    CircleIcon,
    DiscIcon,
    Multiselect,
    CalendarIcon,
    XIcon,
  },
})
export default class EditTaskModal extends mixins(BaseMixin, FormMixin) {
  @Prop({ required: false, type: [Object] })
  selectedTask!: ITask | null;

  /** When true (e.g. opened from PolicyForm), do not navigate to the tasks2 route after save/delete. */
  @Prop({ type: Boolean, default: false })
  suppressTasks2Route!: boolean;

  tags: ITag[] = [];

  model = this.defaultModel();
  isContentHovered = false;
  detailLoading = false;

  defaultModel(): TaskModel {
    if (!this.selectedTask) {
      return {
        title: '',
        newUploadedFiles: [],
      } as TaskModel;
    }
    return {
      ...this.selectedTask,
      newUploadedFiles: [],
    };
  }

  async mounted() {
    this.$root.$on('bv::modal::show', async (bvEvent: Event, modalId: string) => {
      if (modalId === 'create-task') {
        await this.loadTags();
      }
    });
    this.model = { ...this.defaultModel() };
  }

  async destroyed() {
    this.$root.$off('bv::modal::show');
  }

  @Watch('selectedTask', { immediate: true })
  async watchSelectedTask() {
    if (!this.selectedTask?.id) {
      this.model = this.defaultModel();
      this.detailLoading = false;
      return;
    }

    this.detailLoading = true;
    this.model = {
      id: this.selectedTask.id,
      title: this.selectedTask.title ?? '',
      newUploadedFiles: [],
      steps: [],
    } as TaskModel;
    try {
      const res = await TaskApi.getTaskDetail(this.selectedTask.id);
      const t = res.data;
      this.model = {
        ...t,
        customer: t.customerEntity ? formatCustomerDisplayName(t.customerEntity) : '',
        newUploadedFiles: [],
      };
    } catch (e) {
      this.$toastr.e('Aufgabe konnte nicht geladen werden.');
      this.model = {
        ...this.selectedTask,
        customer: this.selectedTask?.customerEntity
          ? formatCustomerDisplayName(this.selectedTask.customerEntity)
          : '',
        steps: [],
        newUploadedFiles: [],
      } as TaskModel;
      await this.loadStepsFallback();
    } finally {
      this.detailLoading = false;
    }
  }

  async loadStepsFallback() {
    if (!this.model.id) return;
    try {
      const steps = await TaskApi.getSteps(this.model.id!);
      this.model.steps = steps.data;
    } catch (e) {
      console.log(e);
    }
  }

  async ok(evt: Event) {
    if (!this.model?.id || this.detailLoading) {
      return;
    }
    evt.preventDefault();
    const taskForm = this.$refs['taskform'] as TaskForm | undefined;
    if (!taskForm) {
      return;
    }
    const commentbox = taskForm.$refs['commentbox'] as any;

    if (commentbox.value?.text) {
      this.model.newComments = [
        {
          id: 'new-comment',
          isDemo: false,
          text: commentbox.value?.text,
          createdAt: new Date(),
          updatedAt: new Date(),
          user: this.user!,
        },
      ];
    }

    try {
      this.isLoading = true;
      const response = await TaskApi.update(this.model.id, {
        title: this.model.title,
        description: this.model.description,
        important: this.model.important,
        status: this.model.status,
        priority: this.model.priority,
        users: this.model.users,
        dueAt: this.model.dueAt,
        tags: this.model.tags,
        agency: this.agency,
        newUploadedFiles: this.model.newUploadedFiles,
        files: this.model.files,
        newComments: this.model.newComments,
        isPrivate: this.model.isPrivate,
        customer: this.model.customer?.trim() || '',
        customerId:
          (taskForm as TaskForm).findCrmCustomerOption(this.model.customer || '')?.id ||
          this.model.customerId ||
          undefined,
      });
      this.model = { ...this.defaultModel() };
      this.$emit('reload');
      this.$emit('update-task', response.data);

      this.$nextTick(() => {
        if (!this.suppressTasks2Route) {
          this.$router.push({ name: 'tasks2' });
        }
        (this.$refs['edit-task'] as BModal).hide();
      });
    } catch (e) {
      const apiErrors = this.exceptionErrors(e);

      this.errorHandling(apiErrors);
      this.$toastr.e('Beim Speichern der Aufgabe ist etwas schief gelaufen.', 'Oops');
      throw e;
    } finally {
      this.isLoading = false;
    }
  }

  errorHandling(apiErrors: Record<string, string>) {
    this.addError(
      apiErrors['titleisNotEmpty'] || apiErrors['titleminLength'],
      'title',
      'Bitte eine Bezeichnung für die Aufgabe angeben.',
    );
  }

  /**
   * Fires after the modal is fully hidden for any reason (Abbrechen, ESC, backdrop, programmatic hide).
   * Keeps the parent route/state in sync; @cancel/@close do not reliably run for ESC in bootstrap-vue.
   */
  onModalHidden() {
    this.$emit('closed');
  }

  cancelDeletion() {
    //
  }

  async confirmDeletion() {
    if (!this.model?.id || this.detailLoading) return;
    try {
      await TaskApi.delete(this.model.id);

      this.$bvModal.hide('modal-delete-task');
      (this.$refs['edit-task'] as BModal).hide();
      this.$emit('reload');
      this.$emit('delete-task', this.model);
      this.$toastr.s(`Aufgabe ${this.model.title} erfolgreich gelöscht.`, 'Aufgabe gelöscht');

      this.$nextTick(() => {
        if (!this.suppressTasks2Route) {
          this.$router.push({ name: 'tasks2' });
        }
      });
    } catch (e) {
      this.$toastr.e('Beim Löschen der Aufgabe ist etwas schief gelaufen.');
      throw e;
    }
  }

  async loadTags() {
    try {
      const response = await TagApi.getTags({
        agency: this.user.agency,
        category: TagCategory.Tasks,
      });
      this.tags = response.data;
    } catch (e) {
      console.log(e);
    }
  }

  async addTag(name: string) {
    try {
      const response = await TagApi.create({
        tag: {
          name,
        },
      });

      const newTag = response.data;

      if (!this.model.tags) {
        this.model.tags = [];
      }
      this.model.tags.push(newTag);
    } catch (e) {
      console.log(e);
    }
  }
}
